/**
 * The contents of this file are subject to the license and copyright
 * detailed in the LICENSE_ATMIRE and NOTICE_ATMIRE files at the root of the source
 * tree and available online at
 *
 * https://www.atmire.com/software-license/
 */
import { Component } from '@angular/core';
import { CommunityDataService } from '../../../../../app/core/data/community-data.service';
import { RouteService } from '../../../../../app/core/services/route.service';
import { Router } from '@angular/router';
import { Collection } from '../../../../../app/core/shared/collection.model';
import { CollectionDataService } from '../../../../../app/core/data/collection-data.service';
import { NotificationsService } from '../../../../../app/shared/notifications/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { RequestService } from '../../../../../app/core/data/request.service';
import { DSONameService } from '../../../../../app/core/breadcrumbs/dso-name.service';
import { AtmireCreateComColPageComponent } from '../../../../../app-atmire/shared/comcol/comcol-forms/create-comcol-page/atmire-create-comcol-page.component';

/**
 * Component that represents the page where a user can create a new Collection
 */
@Component({
  selector: 'ds-create-collection',
  styleUrls: ['./create-collection-page.component.scss'],
  templateUrl: './create-collection-page.component.html'
})
export class CreateCollectionPageComponent extends AtmireCreateComColPageComponent<Collection> {
  protected frontendURL = '/collections/';
  protected type = Collection.type;

  public constructor(
    protected communityDataService: CommunityDataService,
    protected collectionDataService: CollectionDataService,
    protected routeService: RouteService,
    protected router: Router,
    protected notificationsService: NotificationsService,
    protected translate: TranslateService,
    protected requestService: RequestService,
    protected dsoNameService: DSONameService,
  ) {
    super(collectionDataService, communityDataService, routeService, router, notificationsService, translate, requestService, dsoNameService);
  }
}
